import { render } from "./ModifiedObjectPen.vue?vue&type=template&id=2b9c2861"
import script from "./ModifiedObjectPen.vue?vue&type=script&lang=js"
export * from "./ModifiedObjectPen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__